import {
  Alert,
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import {
  CHECK_OUT,
  CREATE_GROUP_MEETING,
  GET_DETAILS_BY_MOBILE_NUMBER,
  STATE_API,
} from "../../constants";
import { Eraser } from "lucide-react";

const AddGroupMeetingComponent = ({}) => {
  const [entries, setEntries] = useState([]);
  const [form, setForm] = useState({
    customer_name: "",
    mobile: "",
    pincode: "",
    location: "",
    group_meeting_title: "",
    is_unique: "",
    bdm_id: localStorage.getItem("username"),
    nearestBranch: "",
    meeting_location: "",
  });
  const [mobileLoading, setMobileLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");
  const [leadData, setLeadData] = useState([]);
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [locationList, setLocationList] = useState([]);

  const location = useLocation();
  const { travelDetailId, bdmLeadActionId } = location.state || {};

  const [title, setTitle] = useState("");
  const [nearestBranch, setNearestBranch] = useState("");
  const [address, setAddress] = useState("");

  const [lat, setLat] = useState("");
const [long, setLong] = useState("");

useEffect(() => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLat(position.coords.latitude);
        setLong(position.coords.longitude);
      },
      (error) => {
        console.error("Error getting location:", error);
        // Optionally show a message or fallback
        setMessage("Unable to retrieve location. Please check your settings.");
        setSeverity("error");
        setOpenSnackbar(true);
      }
    );
  } else {
    console.error("Geolocation is not supported by this browser.");
    setMessage("Geolocation is not supported by this device.");
    setSeverity("error");
    setOpenSnackbar(true);
  }
}, []);

  const navigate = useNavigate();

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    // Live validation as the user types
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let errorMsg = "";

    if (name === "customer_name") {
      if (!value.trim()) {
        errorMsg = "Name is required";
      }
    }

    if (name === "mobile") {
      if (!value) {
        errorMsg = "Mobile number is required";
      } else if (!/^\d{10}$/.test(value)) {
        errorMsg = "Enter a valid 10-digit mobile number";
      }
    }

    if (name === "pincode") {
      if (!value) {
        errorMsg = "Pincode is required";
      } else if (!/^\d{6}$/.test(value)) {
        errorMsg = "Enter a valid 6-digit pincode";
      }
    }

    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };

  const validateForm = () => {
    let newErrors = {};

    if (!form.customer_name.trim())
      newErrors.customer_name = "Name is required";

    if (!form.mobile) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(form.mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number";
    }

    if (!form.pincode) {
      newErrors.pincode = "Pincode is required";
    } else if (!/^\d{6}$/.test(form.pincode)) {
      newErrors.pincode = "Enter a valid 6-digit pincode";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };

  const handleAddEntry = () => {
    if (validateForm()) {
      // Check if the mobile number already exists in the entries array
      const isDuplicate = entries.some((entry) => entry.mobile === form.mobile);

      if (isDuplicate) {
        alert("This mobile number has already been added.");
        return; // Don't add the entry if it's a duplicate
      }

      console.log("Form submitted successfully!", form);

      

      // Add the new entry
      setEntries([...entries, form]);

      // Reset form after adding entry
      setForm((prev) => ({
        ...prev,
        customer_name: "",
        mobile: "",
        pincode: "",
        location: "",
        is_unique: "",
      }));

      setErrors({}); // Reset errors
    }
  };

  const handleDeleteEntry = (index) => {
    setEntries(entries.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    console.log("Submitted Entries:", entries);
    try {
      const payload = {
      bdmLeadActionId,
      travelDetailId,
      latitude:lat,
      longitude: long,
      meetingData: entries,
    };
      const response = await axios.post(`${CREATE_GROUP_MEETING}`, payload);
      setMessage(response.data.message);
      setSeverity("success");
      setOpenSnackbar(true);
      setEntries([]);
      // confirmCheckout();
      navigate("/groupMeeting");
    } catch (error) {
      console.error("Error submitting actions:", error);
    }
  };

  const fetchMobileData = async (mobile) => {
    setMobileLoading(true);

    axios
      .get(`${GET_DETAILS_BY_MOBILE_NUMBER}/${mobile}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { lead } = response.data;

        if (!lead || Object.keys(lead).length === 0) {
          setForm((prevForm) => ({
            ...prevForm,
            is_unique: "yes", // No data found, so it's unique
          }));
          return; // Exit early
        }
        if (
          response.data.message === "Lead not found for the given mobile number"
        ) {
          setForm((prevForm) => ({
            ...prevForm,
            is_unique: "yes", // No data found, so it's unique
          }));
          setSeverity("success");
          setMessage("Lead not found for the given mobile number");
          setOpenSnackbar(true);
        } else {
          form.customer_name = lead.CustomerName;
          form.pincode = lead.pincode;
          form.location = lead.location;
          form.is_unique = "no";
        }
      })
      .catch((error) => {
        // setMobileNumberError("Failed to fetch data. Please try again.");
        setErrors((prev) => ({
          ...prev,
          mobile: "Failed to fetch data. Please try again.",
        }));
      })
      .finally(() => {
        setMobileLoading(false); // Stop loading
      });
  };

  //  const fetchPincodeData = (pincode) => {
  //   setPincodeLoading(true);
  //   axios
  //     .get(`${STATE_API}/${pincode}`)
  //     .then((response) => {
  //       if (response.data == null) {
  //         setSeverity("error");
  //         setMessage("No Data for this pincode");
  //         setOpenSnackbar(true);
  //         setLocationList([]);
  //         return;
  //       }

  //       //Map region so can be used for region feild
  //       const namesArray = response.data.places.map((item) => ({
  //         names: item.placeName,
  //       }));

  //       setLocationList(namesArray);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching pincode data:", error);
  //       setMessage(error.response?.data?.error || "Failed to fetch data");
  //       setSeverity("error");
  //       setOpenSnackbar(true);
  //       //   setStateError("Failed to fetch state. Please try again.");
  //     })
  //     .finally(() => {
  //       setPincodeLoading(false); // Stop loading
  //     });
  // };

  const fetchPincodeData = (pincode) => {
    setPincodeLoading(true);
    axios
      .get(`https://api.postalpincode.in/pincode/${pincode}`)
      .then((response) => {
        if (response.data[0].PostOffice == null) {
          setSeverity("error");
          setMessage(response.data[0].Message);
          setOpenSnackbar(true);
          setLocationList([]);
          return;
        }

        //Map region so can be used for region feild
        const namesArray = response.data[0].PostOffice.map((item) => ({
          names: item.Name,
        }));

        setLocationList(namesArray);
      })
      .catch((error) => {
        console.error("Error fetching pincode data:", error);
        //   setStateError("Failed to fetch state. Please try again.");
      })
      .finally(() => {
        setPincodeLoading(false); // Stop loading
      });
  };

  // Trigger API call once mobile number reaches 10 digits
  useEffect(() => {
    if (form.mobile.length === 10) {
      fetchMobileData(form.mobile);
    }
  }, [form.mobile]);

  useEffect(() => {
    if (form.pincode && form.pincode.length === 6) {
      fetchPincodeData(form.pincode);
    }
  }, [form.pincode]);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleClearForm = () => {
    setForm((prevForm) => ({
      ...prevForm, // Keep all existing values intact
      customer_name: "",
      mobile: "",
      pincode: "",
      location: "",
    }));

    setLocationList([]); // Clear location list if needed
    setLeadData([]); // Clear lead data if needed
  };

  const confirmCheckout = () => {
    console.log("checkIn");
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        // Create the payload with the task details and location data
        const payload = {
          travelDetailId: travelDetailId,
          bdmLeadActionId: bdmLeadActionId,
          latitude: latitude,
          longitude: longitude,
        };

        try {
          const response = await axios.post(`${CHECK_OUT}`, payload);

          setMessage(response.data.message);
          setSeverity("success");
          setOpenSnackbar(true);
        } catch (error) {
          console.error("Error submitting actions:", error);
        }
      },
      (error) => {
        // Handle error when geolocation fails
        console.error("Error fetching location:", error);
        // Set a fallback location or show an error message
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  };

  return (
    <>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link underline="hover" key="1" color="inherit" to="/groupMeeting">
          Group Meeting
        </Link>

        <Typography key="2" color="primary">
          Add Group Meeting
        </Typography>
      </Breadcrumbs>

      <Box sx={{ maxWidth: 500, mx: "auto", mt: 3, p: 2 }}>
        <Card
          sx={{
            p: 1,
            borderRadius: 3,
            boxShadow: 4,
            bgcolor: "#F9FAFB",
            mb: 2,
          }}
        >
          <CardContent>
            <Typography
              variant="h6"
              align="center"
              gutterBottom
              sx={{ fontWeight: "bold" }}
            >
              Meeting Information
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Title"
                  name="group_meeting_title"
                  value={form.group_meeting_title}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  size="small"
                  InputProps={{
                    inputProps: { maxLength: 100 },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Nearest Branch"
                  name="nearestBranch"
                  value={form.nearestBranch}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Address"
                  name="meeting_location"
                  value={form.meeting_location}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  size="small"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Card sx={{ p: 3, borderRadius: 3, boxShadow: 4, bgcolor: "#F9FAFB" }}>
          <CardContent>
            <Typography
              variant="h6"
              align="center"
              gutterBottom
              sx={{ fontWeight: "bold" }}
            >
              Customer Information
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Mobile Number"
                  name="mobile"
                  value={form.mobile}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  size="small"
                  error={!!errors.mobile}
                  helperText={errors.mobile}
                  InputProps={{
                    inputProps: { maxLength: 10 },
                    endAdornment: mobileLoading && (
                      <InputAdornment position="end">
                        <CircularProgress size={20} />
                      </InputAdornment>
                    ),
                  }}
                  onKeyDown={(e) => {
                    if (
                      !/^[0-9]$/.test(e.key) &&
                      e.key !== "Backspace" &&
                      e.key !== "ArrowLeft" &&
                      e.key !== "ArrowRight" &&
                      e.key !== "Delete" &&
                      e.key !== "Tab"
                    ) {
                      e.preventDefault(); // Block non-numeric keys
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Name"
                  name="customer_name"
                  value={form.customer_name}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  size="small"
                  error={!!errors.customer_name}
                  helperText={errors.customer_name}
                  onKeyDown={(e) => {
                    if (!/^[A-Za-z\s]$/.test(e.key) && e.key !== "Backspace") {
                      e.preventDefault(); // Block invalid keys
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Pincode"
                  name="pincode"
                  value={form.pincode}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  error={!!errors.pincode}
                  helperText={errors.pincode}
                  InputProps={{
                    inputProps: {
                      maxLength: 6, // Pincode should be 6 digits max
                      inputMode: "numeric", // Optimized for mobile numeric input
                    },
                    endAdornment: pincodeLoading ? (
                      <InputAdornment position="end">
                        <CircularProgress size={20} />
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Location"
                  name="location"
                  value={form.location}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                >
                  {locationList.map((pl) => (
                    <MenuItem value={pl.names} key={pl.names}>
                      {pl.names}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2} justifyContent="center">
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddCircleOutlineIcon />}
                      onClick={handleAddEntry}
                    >
                      Add More
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="secondary"
                      startIcon={<Eraser />}
                      onClick={handleClearForm}
                    >
                      Clear
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {entries.length > 0 && (
          <Box sx={{ mt: 3 }}>
            {entries.map((entry, index) => (
              <Card
                key={index}
                sx={{
                  mb: 2,
                  p: 0,
                  borderRadius: 2,
                  boxShadow: 2,
                  bgcolor: "#FFFFFF",
                  display: "flex",
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "stretch",
                    height: "100%",
                    width: "100%",
                    p: 0,
                    pb: "0px !important",
                    justifyContent: "space-between", // Evenly space the details and action
                    gap: "8px",
                  }}
                >
                  {/* Full-height colored SNo section */}
                  <Box
                    sx={{
                      width: 40,
                      backgroundColor: "#228B22",
                      color: "#fff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "2px 0 0 2px", // Rounded corners to the left side
                      padding: "8px 0",
                      marginRight: 2,
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                      {index + 1}
                    </Typography>
                  </Box>

                  <Box sx={{ flexGrow: 1, padding: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                      Name: {entry.customer_name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      <strong>Mobile:</strong> {entry.mobile}
                    </Typography>
                  </Box>

                  <Box sx={{ padding: 2, left: 0 }}>
                    <IconButton
                      onClick={() => handleDeleteEntry(index)}
                      color="error"
                      sx={{ alignSelf: "center" }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}

        {entries.length >= 5 && (
          <Box textAlign="center" sx={{ mt: 3 }}>
            <Button
              variant="contained"
              color="success"
              onClick={handleSubmit}
              sx={{ fontWeight: "bold" }}
            >
              Submit
            </Button>
          </Box>
         )} 
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000} // Snackbar will auto hide after 6 seconds
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddGroupMeetingComponent;
